import React, { useState, useEffect, Fragment } from 'react';
import MultiSelectVertical from '../../../MultiSelectVertical/MultiSelectVertical';
import SingleSelectHorizontal from '../../../SingleSelectHorizontal/SingleSelectHorizontal';
import SingleSelectVertical from '../../../SingleSelectVertical/SingleSelectVertical';
import './Tabs.scss';
import Button from '../../../../partials/Button/Button';
import Scroll from '../../../../partials/Scroll/Scroll';
import Media from './../../../../partials/Media/index';

const Tabs = (props) => {

  const { data, children, currentTab, nextTab, changeTab, prevPage, nextPage, changePage, page, changeActionVisibility, retryQuiz, onComplete } = props;

  const [currentStep, setCurrentStep] = useState(0);


  const nextStep = (err) => {
    let errors = 0;
    let steps = data.tabs[currentTab].steps;
    if (err) {
      steps[currentStep].completed = false;
    } else {
      steps[currentStep].completed = true;
    }

    // filter for imcomplete steps
    steps.forEach((step) => {
      if (!step.completed) {
        errors += 1;
      }
    });

    const stepsLength = data.tabs[currentTab].steps.length;
    if (currentStep + 1 < stepsLength) {
      setCurrentStep(currentStep + 1);
    } else {
      nextTab()
    }
  }

  const sectionCompleted = (arr) => {
    return arr ? arr.every((item) => item.clicked === true) : false
  }

  return (
    <div className="tabs">
      {data.tabs.map((tab, tabIndex) => (
        <Fragment key={`tab-fragment-${tabIndex}`}>
          {tab.type === 'instructions' ?

            <div className={`tab-content ${tabIndex === currentTab ? 'active' : ''}`} key={`tab-content-${tabIndex}`}>

              {tab.sections.map((section, sectionIndex) => {
                return (
                  <div className={`section ${page === sectionIndex ? 'active' : ''}`} key={`section-${sectionIndex}`}>
                    <div className="flex3">
                      <div className="conc_bdr">
                        <h2 className="mb-2 section-title">{section.title}</h2>
                        <Scroll>
                          < div className="section-content" dangerouslySetInnerHTML={{ __html: section.content }}></div>
                        </Scroll>
                      </div>
                      <div className="section-actions">
                        {section.actions.map((action, actionIndex) =>
                          <button className={action.variant} key={`section-${sectionIndex}-${actionIndex}`} onClick={() => { changeActionVisibility(tabIndex, sectionIndex, actionIndex) }}>

                            {action.title}
                          </button>
                        )
                        }
                        {page !== tab.sections.length - 1 && (!section.actionsRequired || sectionCompleted(section.actions)) && <div className={"NextButton"}><Button text="Next" className={"center"} size="wide" onClick={() => nextPage()} /></div>}
                        {page === tab.sections.length - 1 &&
                          <Button text={section.button} className={"center"} size="wide" onClick={nextTab} />
                        }
                      </div>
                    </div>
                    <div className="flex2 pl-1">
                      <div className="rt_cnt_top">
                        {section.image !== "" && <Media src={section.image} alt={section.alt} className="img-responsive img_bdr" />}
                        {section.actions.map((action, actionIndex) =>
                          <div className={`section-desc ${action.active ? 'active' : ''}`} key={`section-desc-${actionIndex}`}>
                            <h3>{action.title}</h3>
                            <Scroll>
                              <div className="sect_desc_cnt" dangerouslySetInnerHTML={{ __html: action.desc }}></div>
                            </Scroll>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            : tab.type === 'quiz' ?
              <div className={`tab-quiz ${tabIndex === currentTab ? 'active' : ''}`} key={`tab-quiz-${tabIndex}`}>

                {tab.steps.map((step, stepIndex) => {
                  if (currentStep === stepIndex) {

                    if (step.type === 'single-selection') {
                      if (step.orientation === 'horizontal') {
                        return <SingleSelectHorizontal
                          data={step}
                          onComplete={nextStep}
                          instructionText={tab.instructionText}
                        />;
                      } else {
                        return <SingleSelectVertical
                          data={step}
                          onComplete={nextStep}
                        />
                      }
                    } else if (step.type === 'multiple-selection') {
                      return <MultiSelectVertical
                        data={step}
                        onComplete={nextStep}
                      />
                    }
                  }
                })}
              </div>
              : tab.type === 'keytakeaway' ?
                <div className={`tab-keytakeaway ${tabIndex === currentTab ? 'active' : ''}`} key={`tab-keytakeaway-${tabIndex}`}>
                  {tab.sections.map((section, sectionIndex) => {
                    return (
                      <div className={`section ${page === sectionIndex ? 'active' : ''}`} key={`section-${sectionIndex}`}>
                        <div className="flex3 conc_bdr">
                          <h2 className="mb-2 section-title">{section.title}</h2>
                          <div className="section-content" dangerouslySetInnerHTML={{ __html: section.content }}></div>
                          <Button text="Continue" onClick={() => onComplete()} />
                        </div>
                        <div className="flex2 pl-1">

                          {section.image !== "" && <Media src={section.image} alt={section.title} className="img-responsive img_bdr" />}
                        </div>
                      </div>
                    );

                  })}
                </div>
                :
                ""}
        </Fragment>
      ))}
    </div>
  );

};

export default Tabs;